import { render, staticRenderFns } from "./standardDetail.vue?vue&type=template&id=a016b5bc&scoped=true"
import script from "./standardDetail.vue?vue&type=script&lang=js"
export * from "./standardDetail.vue?vue&type=script&lang=js"
import style0 from "./standardDetail.vue?vue&type=style&index=0&id=a016b5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a016b5bc",
  null
  
)

export default component.exports